import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classnames from 'classnames'
import styled from 'styled-components'

import {
  CustomInput,
  Form,
  FormGroup,
  Label,
  Input,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Container,
  Row,
  Col,
} from 'reactstrap'
import moment from '../../lib/moment.js'

import { status } from '../../constants'

const url = 'https://www.materialui.co/materialIcons/navigation/cancel_black_192x192.png'

class CompanyForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: '1',
    }
  }

  render() {
    return (
      /* eslint no-underscore-dangle: 0 */
      <Background>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={ classnames({ active: this.state.activeTab === '1' }) }
              onClick={ () => {} }
            >
              Company Information
            </NavLink>
          </NavItem>
          <Image
            src={ url }
            onClick={ _.get(this.props, 'confirm') === 'companyForm' ? this.props.cancelForm : this.props.showDiscard }
          />
        </Nav>
        <TabContent activeTab={ this.state.activeTab } >
          <TabPane tabId="1">
            <Row>
              <Col sm="12">
                <Form>
                  <FormGroup>
                    <Container >
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Start Date</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <InputFieldDate
                            autoComplete='off'
                            name="start_date"
                            type="date"
                            disabled={ !_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined }
                            value={ moment(_.get(this.props, 'start_date')).format('YYYY-MM-DD') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Company ID</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <InputField
                            name="company_code"
                            disabled={ !_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined }
                            placeholder="Enter Company ID"
                            value={ _.get(this.props, 'company_code') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Company Name</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <InputField
                            name="company"
                            disabled={ !_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined }
                            placeholder="Enter Company Name"
                            value={ _.get(this.props, 'company') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      {
                        _.get(this.props, 'create') === undefined &&
                        <Row style={ { marginTop: 10 } }>
                          <Col sm={ 3 }><Label>Status</Label></Col>
                          <Col sm={ 9 }>
                            <CustomInputField
                              type="select"
                              id="is_active"
                              name="is_active"
                              disabled={ !_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined }
                              value={ this.props.is_active }
                              onChange={ this.props.handleInput }
                            >
                              {
                                status.map((s, key) => <option key={ key } value={ s.value }>{ s.label }</option>)
                              }
                            </CustomInputField>
                          </Col>
                        </Row>
                      }
                    </Container>

                  </FormGroup>
                  <Right>
                    { _.get(this.props, 'button') }
                  </Right>
                </Form>
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </Background>
    )
  }
}

CompanyForm.propTypes = {
  handleInput: PropTypes.func.isRequired,
  cancelForm: PropTypes.func.isRequired,
  showDiscard: PropTypes.func.isRequired,
}

export default CompanyForm

const Right = styled.div`
  background-color: white;
  padding: 10px;
  text-align: right;
`
const Background = styled.div`
  background-color: white;
  padding: 10px;
  font-family: 'Gotham-Bold' !important;
  font-size: 14px ;
`
const InputField = styled(Input)`
  font-family: 'Gotham' !important;
  width : 100% ;
  height : 100% ;
  font-size: 12px ;
`
const InputFieldDate = styled(Input)`
  font-family: 'Gotham' !important;
  width : 100% ;
  height : 100% ;
  font-size: 12px ;
  float: right;
  ::-webkit-inner-spin-button {
    display: none;
    -webkit-appearance: none;
  }
`
const Image = styled.img`
  width: 20px;
  height: 20px;
  position: absolute;
  right: 10px;
`
const CustomInputField = styled(CustomInput)`
  font-family: 'Gotham' !important;
  width : 100% ;
  height : 100% ;
  font-size: 12px ;
`



// WEBPACK FOOTER //
// ./src/components/company/index.js